var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNinjaAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6299_252450)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2898 28.8333V33.1226H7.41254V28.8333C7.42488 28.8165 7.43898 28.7976 7.45484 28.7767C7.5313 28.676 7.64859 28.5294 7.80765 28.3521C8.12596 27.9972 8.61012 27.521 9.26749 27.044C10.5798 26.0919 12.5838 25.1352 15.3512 25.1352C18.1186 25.1352 20.1226 26.0919 21.4349 27.044C22.0923 27.521 22.5764 27.9972 22.8947 28.3521C23.0538 28.5294 23.1711 28.676 23.2475 28.7767C23.2634 28.7976 23.2775 28.8165 23.2898 28.8333Z",
    fill: "#FFBA07",
    stroke: "#2B2B2B",
    strokeWidth: 0.793825
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4917 33.5088C12.3116 33.5088 9.23775 29.3446 8.90625 26.6375L10.7173 25.5957C10.8819 26.9403 13.2311 31.2267 20.4917 31.2267V33.5088Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.85597 33.5088C18.036 33.5088 21.1099 29.3446 21.4414 26.6375L19.6304 25.5957C19.4657 26.9403 17.1165 31.2267 9.85597 31.2267V33.5088Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4792 17.3462C25.4792 22.9511 20.9355 27.4948 15.3306 27.4948C9.72573 27.4948 5.18207 22.9511 5.18207 17.3462C5.18207 11.7414 9.72573 7.19769 15.3306 7.19769C20.9355 7.19769 25.4792 11.7414 25.4792 17.3462Z",
    fill: "#808080",
    stroke: "#2B2B2B",
    strokeWidth: 0.793825
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1857 17.6679L15.1856 17.6679L15.1846 17.6688L15.1794 17.6728L15.1576 17.6897C15.138 17.7048 15.1085 17.7274 15.07 17.7565C14.9929 17.8146 14.8801 17.8984 14.7389 17.9996C14.456 18.2024 14.0612 18.4736 13.6131 18.748C13.1639 19.0231 12.6683 19.297 12.1829 19.5084C11.6915 19.7225 11.2413 19.8589 10.8755 19.885C10.1214 19.9389 9.08008 19.5769 8.16042 19.1451C7.71488 18.9359 7.32222 18.7222 7.04081 18.5607C6.95955 18.5141 6.88778 18.4719 6.82692 18.4356V14.6452C6.97956 14.5943 7.18041 14.5282 7.4208 14.4516C8.00192 14.2662 8.81275 14.0192 9.73113 13.7722C11.5819 13.2746 13.8187 12.7918 15.4939 12.7918C17.169 12.7918 19.4058 13.2746 21.2566 13.7722C22.175 14.0192 22.9858 14.2662 23.567 14.4516C23.8074 14.5282 24.0082 14.5943 24.1608 14.6452V18.4356C24.1 18.4719 24.0282 18.5141 23.947 18.5607C23.6655 18.7222 23.2729 18.9359 22.8273 19.1451C21.9077 19.5769 20.8663 19.9389 20.1123 19.885C19.7465 19.8589 19.2963 19.7225 18.8049 19.5084C18.3195 19.297 17.8239 19.0231 17.3747 18.748C16.9266 18.4736 16.5318 18.2024 16.2489 17.9996C16.1076 17.8984 15.9948 17.8146 15.9178 17.7565C15.8793 17.7274 15.8498 17.7048 15.8302 17.6897L15.8083 17.6728L15.8032 17.6688L15.8021 17.6679L15.802 17.6679L15.802 17.6678L15.802 17.6678L15.4939 17.4258L15.1858 17.6678L15.1858 17.6678L15.1857 17.6679Z",
    fill: "#FFBA07",
    stroke: "#2B2B2B",
    strokeWidth: 0.997595
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.4492,
    y: 15.6406,
    width: 1.57342,
    height: 2.41675,
    rx: 0.198456,
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.8594,
    y: 15.6406,
    width: 1.57342,
    height: 2.41675,
    rx: 0.198456,
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5758 9.83066C24.1364 9.9804 23.5797 9.99405 22.8707 9.75584C22.823 9.07062 22.9552 8.15194 23.4786 7.38329C24.0059 6.60888 24.9673 5.93233 26.6945 5.83785C26.6118 6.80432 26.3392 7.98478 25.778 8.83217C25.4599 9.31243 25.0636 9.66443 24.5758 9.83066Z",
    fill: "#808080",
    stroke: "#2B2B2B",
    strokeWidth: 0.793825
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5735 10.8447C24.128 10.714 23.6651 10.4046 23.2227 9.80159C23.5784 9.21394 24.2157 8.53904 25.0863 8.21209C25.9634 7.8827 27.1391 7.88331 28.6054 8.80074C27.9811 9.54316 27.0783 10.3512 26.1314 10.7207C25.5947 10.9302 25.0681 10.9897 24.5735 10.8447Z",
    fill: "#808080",
    stroke: "#2B2B2B",
    strokeWidth: 0.793825
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6299_252450"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNinjaAvatar);
export default __webpack_public_path__ + "static/media/ninja-avatar.c8f48dde5b489212c4c381e7666ae551.svg";
export { ForwardRef as ReactComponent };